//CITY HERO VIDEOS START
const videosWrapper = document.querySelectorAll('.js-video-play');
if (videosWrapper.length > 0) {
    videosWrapper.forEach(videoWrapper => {
        const videos = videoWrapper.querySelectorAll('video');
        const svgButtons = videoWrapper.querySelectorAll('svg');

        videos.forEach(video=>{
            if (window.getComputedStyle(video).display !== 'none'){
                video.play();
            }
        })

        toggleVideoSvgs(svgButtons);

        videoWrapper.addEventListener('click', ()=>{
            videos.forEach(video=>{
                if (window.getComputedStyle(video).display !== 'none'){
                    if (video.paused) {
                        video.play();
                    } else {
                        video.pause();
                    }
                }
            });
            toggleVideoSvgs(svgButtons);
        })

    });
}

function toggleVideoSvgs(svgs){
    svgs.forEach(svgButton=>{
        svgButton.classList.toggle('hidden');
    });
}
//CITY HERO VIDEOS END